"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPayrollShiftFacilityDto = instanceOfPayrollShiftFacilityDto;
exports.PayrollShiftFacilityDtoFromJSON = PayrollShiftFacilityDtoFromJSON;
exports.PayrollShiftFacilityDtoFromJSONTyped = PayrollShiftFacilityDtoFromJSONTyped;
exports.PayrollShiftFacilityDtoToJSON = PayrollShiftFacilityDtoToJSON;
exports.PayrollShiftFacilityDtoToJSONTyped = PayrollShiftFacilityDtoToJSONTyped;
/**
 * Check if a given object implements the PayrollShiftFacilityDto interface.
 */
function instanceOfPayrollShiftFacilityDto(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    return true;
}
function PayrollShiftFacilityDtoFromJSON(json) {
    return PayrollShiftFacilityDtoFromJSONTyped(json, false);
}
function PayrollShiftFacilityDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
    };
}
function PayrollShiftFacilityDtoToJSON(json) {
    return PayrollShiftFacilityDtoToJSONTyped(json, false);
}
function PayrollShiftFacilityDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'timezone': value['timezone'],
    };
}
//# sourceMappingURL=PayrollShiftFacilityDto.js.map